import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space } from '@redlink/components/atoms';
import { Button } from '@redlink/components/molecules';
import { useLocale } from '@redlink/assets/locale';

export const TopTenLinkList = memo(({ data = [] }) => {
  const { dictionary } = useLocale();
  const { styles } = useStyle();

  return (
    <View style={styles.bodyListContainer}>
      <Text style={styles.titleText}>{dictionary.topTen}</Text>
      {data.map((item) => (
        <ListItem {...item} />
      ))}
    </View>
  );
});

const ListItem = memo(({ url, clickCount }) => {
  const { styles } = useStyle();
  return (
    <View style={styles.itemContainer}>
      <Button
        variant="link"
        title={url}
        style={styles.itemTextButton}
        onPress={() => window.open(url, '_blank')}
      />
      <Space />
      <Text style={styles.clickCountText}>{clickCount}</Text>
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  bodyListContainer: {
    flex: 1,
  },
  itemContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  itemTextButton: {
    paddingVertical: 0,
  },
  clickCountText: {
    flex: 1,
    textAlign: 'right',
  },
}));
